import { validationMessage } from 'vuelidate-messages'
import { messages, validationPass } from '@/lib/validation-helpers'
import { required, maxLength } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    formData: {
      name: {
        required,
        maxLength: maxLength(255)
      },
      alternative_name: {
        maxLength: maxLength(255)
      },
      abbreviation: {
        maxLength: maxLength(255)
      },
      currency: {
        required,
        maxLength: maxLength(3)
      },
      website: {
        maxLength: maxLength(255)
      },
      ringgold_id: {
        maxLength: maxLength(255)
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass: validationPass
  }
}
